import { observable, runInAction } from 'mobx';
import { singleton } from 'tsyringe';
import { API } from '~/api';
import { ApiService } from './service.api';

@singleton()
export class StoreService {
	readonly names = observable.array([] as API.StoreName[], { deep: false });

	constructor(private api: ApiService) {}

	useNames() {
		this.api.storeGetNames().then(({ data }) => {
			runInAction(() => this.names.replace(data.items));
		});
	}
}
